<template>
  <div>
    <h4>General Info</h4>
    <validation-observer v-slot="{ invalid }">
      <validation-provider name="Participants" v-slot="context" rules="required">
        <b-form-group label="Participants">
          <b-form-input
            v-model="participants"
            :state="getValidationState(context)"
            v-bind="context.ariaInput"
            type="number"
            :disabled="date.cancelled"
          />

          <b-form-invalid-feedback v-bind="context.ariaMsg">
            {{ context.errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>

      <validation-provider name="Starts" v-slot="context" rules="required">
        <b-form-group label="Starts">
          <b-form-datepicker
            locale="nb-NO"
            :start-weekday="1"
            v-model="starts_at"
            :state="getValidationState(context)"
            v-bind="context.ariaInput"
            :min="new Date()"
            :disabled="date.cancelled"
          />

          <b-form-invalid-feedback v-bind="context.ariaMsg">
            {{ context.errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>

      <validation-provider name="Ends" v-slot="context" rules="required">
        <b-form-group label="Ends">
          <b-form-datepicker
            locale="nb-NO"
            :start-weekday="1"
            v-model="ends_at"
            :state="getValidationState(context)"
            v-bind="context.ariaInput"
            :min="new Date()"
            :disabled="date.cancelled"
          />

          <b-form-invalid-feedback v-bind="context.ariaMsg">
            {{ context.errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>

      <hr />

      <div class="clearfix">
        <b-button variant="primary" :disabled="invalid || date.cancelled" class="pull-right" @click="update">
          Update
        </b-button>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import { booking } from '@youwish1/api-package'
import { getValidationState } from './page-helpers'

export default {
  props: { date: Object },
  data() {
    return {
      participants: this.date.participants,
      starts_at: this.date.starts_at,
      ends_at: this.date.ends_at,
    }
  },
  methods: {
    getValidationState,
    async update() {
      const date = await booking.dates.update(this.date.id, {
        participants: this.participants,
        starts_at: this.starts_at,
        ends_at: this.ends_at,
      })

      this.$bvToast.toast(`Settings updated`, {
        title: 'Booking date updated',
        variant: 'primary',
      })

      this.$emit('updated', { date })
    },
  },
}
</script>
